/**
 * Environment Configuration
 *
 * Centralized environment variables with type safety
 * Mirrors backend env.ts pattern
 */

interface EnvConfig {
  // App
  APP_NAME: string
  APP_VERSION: string
  APP_ENV: 'development' | 'production' | 'test'

  // API
  API_URL: string
  API_TIMEOUT: number
  API_TIMEOUT_SUBIDA: number

  // Feature Flags
  ENABLE_MOCK: boolean
  ENABLE_DEBUG: boolean
}

const parseBoolean = (value: string | undefined): boolean => {
  return value === 'true'
}

const parseNumber = (value: string | undefined, defaultValue: number): number => {
  const parsed = parseInt(value ?? '', 10)
  return isNaN(parsed) ? defaultValue : parsed
}

export const env: EnvConfig = {
  APP_NAME: import.meta.env.VITE_APP_NAME ?? 'JH Lumina',
  APP_VERSION: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
  APP_ENV: (import.meta.env.VITE_APP_ENV as EnvConfig['APP_ENV']) ?? 'development',

  API_URL: import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api/v1',
  API_TIMEOUT: parseNumber(import.meta.env.VITE_API_TIMEOUT, 30000),
  API_TIMEOUT_SUBIDA: parseNumber(import.meta.env.VITE_API_TIMEOUT_SUBIDA, 900000),

  ENABLE_MOCK: parseBoolean(import.meta.env.VITE_ENABLE_MOCK),
  ENABLE_DEBUG: parseBoolean(import.meta.env.VITE_ENABLE_DEBUG),
}

export const isDevelopment = (): boolean => env.APP_ENV === 'development'
export const isProduction = (): boolean => env.APP_ENV === 'production'
export const isTest = (): boolean => env.APP_ENV === 'test'
